import React from 'react';

import styled from '@emotion/styled';

import { HoverDropDown } from '../../../components/DropDown/DropDown';
import DownArrowIcon from '../../../components/Icons/DownArrowIcon';
import IconImg from '../../../components/Img/IconImg';
import { headerConfig } from './headerConfig';
import { ModalProvider } from '../../../context/ModalContext';
import ModalTriggerContainer from '../../../components/Modal/ModalTriggerContainer';
import { Modal } from '../../../components/Modal/Modal';
import ProfileModal from '../../../components/Modal/ModalActions/ProfileModal';
import useOnLogout from '../../../hooks/auth/useHealthLogout';
import { useAppSelector } from '../../../redux/store';
import PostJobModal from '../../../components/Modal/ModalActions/PostJobModal';

const DropDownLabel = ({ src }: { src: string }) => {
  return (
    <DropDownLabelContainer>
      <IconImg src={src} />
      <DownArrowIcon />
    </DropDownLabelContainer>
  );
};

const ShowModal = ({
  children,
  job,
}: {
  children: React.ReactNode;
  guest?: boolean;
  job?: boolean;
}) => {
  return (
    <ModalProvider>
      <ModalTriggerContainer>
        <ShowProfile>{children}</ShowProfile>
      </ModalTriggerContainer>
      <Modal>{job ? <PostJobModal /> : <ProfileModal />}</Modal>
    </ModalProvider>
  );
};

const HealthHeaderDropDown = () => {
  const { logoutHealth } = useOnLogout();
  const { authData } = useAppSelector((state) => state.auth);

  const profileImageSrc =
    authData?.profileImage ?? '/static/img/PlaceholderUserImage.png';

  return (
    <HoverDropDown label={<DropDownLabel src={profileImageSrc} />}>
      <Container>
        <HoverDropDownContentCell>
          <IconImg src={profileImageSrc} />
          <UserInfoArea>
            <p>
              {authData?.firstName} {authData?.lastName}
            </p>
            <Description>{authData?.tier} account</Description>
          </UserInfoArea>
        </HoverDropDownContentCell>
        {headerConfig.map((data, index) => {
          if (data.title === 'Logout') {
            return (
              <HoverDropDownContentCell
                onClick={() => logoutHealth()}
                key={index}
              >
                {data.icon} <p>{data.title}</p>
              </HoverDropDownContentCell>
            );
          }

          if (data.title === 'View Profile') {
            return (
              <HoverDropDownContentCell key={index}>
                {/* <ShowModal> */}
                {data.icon} <p>{data.title}</p>
                {/* </ShowModal> */}
              </HoverDropDownContentCell>
            );
          }

          return (
            <HoverDropDownContentCell key={index}>
              <ShowModal job>
                {data.icon} <p>{data.title}</p>
              </ShowModal>
            </HoverDropDownContentCell>
          );
        })}
      </Container>
    </HoverDropDown>
  );
};

export default HealthHeaderDropDown;

const Container = styled.div`
  width: 16.4375rem;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  cursor: default;
`;

const DropDownLabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const HoverDropDownContentCell = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  color: ${({ theme }) => theme.palette.blackBlackMain};
  font-weight: 400;
  cursor: pointer;
`;

const UserInfoArea = styled.div`
  /* border: 2px solid red; */
`;

const Description = styled.div`
  display: flex;
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 300;
  color: ${({ theme }) => theme.palette.greyGrey1};
`;

const ShowProfile = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
`;
